import { ConfigurationSection } from './config-item/config-item.model';

export const SECTIONS: { [key: string]: ConfigurationSection } = {
  GSL_CONFIGURATIONS: {
    header: $localize`GSL Configurations`,
    data: [
      {
        label: $localize`Position Based Operations`,
        control: 'positionBasedOps',
        hasTooltip: true,
        tooltipText: $localize`Requires lineup (GLE)`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`BLA Enabled`,
        control: 'blaEnabled',
        hasTooltip: false,
        tooltipText: $localize`Bag Load Assist`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`GLS Enabled`,
        control: 'glsEnabled',
        hasTooltip: true,
        tooltipText: $localize`Ability to recieve messages`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Security Screening`,
        control: 'securityScreening',
        hasTooltip: true,
        tooltipText: $localize`Receives Security Screen alerts from OPSYS`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Inbound Scanning`,
        control: 'inbound',
        hasTooltip: true,
        tooltipText: $localize`Import data downloads`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Carry Over`,
        control: 'carryOver',
        hasTooltip: true,
        tooltipText: $localize`Sites building loads over multiple sorts/days`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`TLS Smart`,
        control: 'tslSmartEnabled',
        hasTooltip: false,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Commodity Verification`,
        control: 'commodityVerification',
        hasTooltip: false,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Enhanced Inbound Scan`,
        control: 'enhancedInboundScan',
        hasTooltip: false,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Bulk PTN Allowed`,
        control: 'bulkPtnAllowed',
        hasTooltip: true,
        tooltipText: $localize`Sites take responsibility to prevent CODs in Bulk loads`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`EDI`,
        control: 'edi',
        hasTooltip: false,
        isExpandable: true,
        expanded: false,
        expandableIndex: 0,
      },
      {
        label: $localize`Manifest Scan Visibility`,
        control: 'manifestVisibility',
        hasTooltip: false,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Allow OPSYS Web Calls`,
        control: 'allowOpsysWebCall',
        hasTooltip: false,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Batch ULD Delete`,
        control: 'deleteUld',
        hasTooltip: true,
        tooltipText: $localize`Enables ULD Delete in Batch mode`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`FTP Scan Events`,
        control: 'ftpScanEvents',
        hasTooltip: true,
        tooltipText: $localize`For FTP Scan feeds`,
        isExpandable: true,
        expanded: false,
        expandableIndex: 1,
      },
      {
        label: $localize`Revenue Recovery`,
        control: 'revRecovery',
        hasTooltip: true,
        tooltipText: $localize`Enables RR and sets the values`,
        isExpandable: true,
        expanded: false,
        expandableIndex: 2,
      },
      {
        label: $localize`Default Sort Schedule`,
        control: 'sortSchedule',
        hasTooltip: true,
        tooltipText: $localize`Only used for AVSEC and/or PDWS sites`,
        isExpandable: true,
        expanded: false,
        expandableIndex: 3,
      },
    ],
  },
  CUSTOMER: {
    header: $localize`Customer`,
    data: [
      {
        label: $localize`CVIS`,
        control: 'cvis',
        hasTooltip: false,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Customer Location(API)`,
        control: 'customerLocationApi',
        hasTooltip: false,
        isExpandable: true,
        expanded: false,
        expandableIndex: 0,
      },
      {
        label: $localize`Customer`,
        control: 'customer',
        hasTooltip: true,
        tooltipText: $localize`For CVIS customers`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`CVIS Smart Enabled`,
        control: 'cvisSmartEnabled',
        hasTooltip: true,
        tooltipText: $localize`Requires "Collect Shippers" option to be selected to update`,
        isExpandable: true,
        expanded: false,
        expandableIndex: 1,
      },
      {
        label: $localize`Customer Counter`,
        control: 'customerCounter',
        hasTooltip: true,
        tooltipText: $localize`For CVIS customers`,
        isExpandable: false,
        expanded: false,
      },
    ],
  },
  EQUIPMENT_HANDLING: {
    header: $localize`Equipment Handling`,
    data: [
      {
        label: $localize`AHCS`,
        control: 'ahcs',
        hasTooltip: true,
        tooltipText: $localize`Air Hub Control System - Equipment Handling system used at certain air gateways. (Worldport & Rockford, IL)`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`TFCS`,
        control: 'tfcs',
        hasTooltip: true,
        tooltipText: $localize`Trailer Forecast and Control System - Equipment Handling system used to manage trailer/feeder movements`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`LH`,
        control: 'loadHandling',
        hasTooltip: true,
        tooltipText: $localize`Load Handling - Equipment Handling system used to manage air movements`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`ALP`,
        control: 'alp',
        hasTooltip: true,
        tooltipText: $localize`Aircraft Load Position`,
        isExpandable: false,
        expanded: false,
      },
    ],
  },
  EXTERNAL_SYSTEMS: {
    header: $localize`External Systems`,
    data: [
      {
        label: $localize`Messaging`,
        control: 'messagingActive',
        hasTooltip: true,
        tooltipText: $localize`Ability to recieve messages`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Intercepts`,
        control: 'intercepts',
        hasTooltip: true,
        tooltipText: $localize`Ability to recieve intercepts`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`GIO`,
        control: 'gioEnabled',
        hasTooltip: true,
        tooltipText: $localize`Enables PLD forecast data to be downloaded to Tundra Server & TSL scanner from GIO`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`OPSYS`,
        control: 'opsys',
        hasTooltip: true,
        tooltipText: $localize`Receives and sends OPSYS messages`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`HMMS`,
        control: 'hmmsEnabled',
        hasTooltip: true,
        tooltipText: $localize`Enables HMMS/HazMat functionality`,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`RCC`,
        control: 'rcc',
        hasTooltip: false,
        isExpandable: false,
        expanded: false,
      },
      {
        label: $localize`Collect Shippers`,
        control: 'collectShippers',
        hasTooltip: false,
        isExpandable: false,
        expanded: false,
      },
    ],
  },
};

export const UNITS = [
  {
    label: $localize`Imperial`,
    value: 'Imperial',
  },
  {
    label: $localize`Metric`,
    value: 'Metric',
  },
];
